<template>
    <div class="chart">
        <div class="d-flex justify-content-between p-3">
            <h2>По типам рейсов</h2>
            <select name="" id="" v-model="type" class="custom-select w-50">
                <option value="weekly">Неделя</option>
                <option value="monthly">Месяц</option>
                <option value="annual">Год</option>
            </select>
        </div>
        <p class="justify-content-between pl-3">{{ routeFromDate + ' - ' + routeToDate }}</p>
        <apexchart ref="chart" type=pie height=350 :options="options" :series="series"/>
    </div>
</template>

<script>
    export default {
        name: "RoutesDashboard",
        data() {
            return {
                type: 'weekly',
                series: [44, 55],
                options: {
                    labels: ['Международный', 'Междугородный'],
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                },
				routeFromDate: '',
				routeToDate: ''
            }
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                let data = {};
                data[this.type] = true;
                this.$api.get('dashboard.trips-count', data)
                    .then(res => {
                        let series = [];
                        series[0] = res.data.data.international;
                        series[1] = res.data.data.local;
						this.routeFromDate = this.$moment(res.data.range.from.date).format('Y-MM-DD');
						this.routeToDate = this.$moment(res.data.range.to.date).format('Y-MM-DD');
                        this.$refs.chart.updateSeries(series);
                    })
            }
        },
        watch: {
            type: function () {
                this.init();
            }
        }
    }
</script>

<style scoped>

</style>
